import React, { FunctionComponent, useEffect, useMemo, useState } from "react";

import { connect, useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";

import { ApplicationState } from "../../../store";
import LoadingIndicator from "../../common/onboarding/LoadingIndicator";
import useUserRole from "../../../utils/hooks/useUserRole";
import { Release_Notes, SuperuserState } from "../../../store/superuser/types";
import { Accordion } from "react-bootstrap";
import ReleaseNoteItem from "./ReleaseNoteItem";
import { getAllReleaseNotes } from "../../../store/superuser/actions";
import { useLocation } from "react-router";


const ReleaseNotesTable: FunctionComponent = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const noteYearParam = params.get("year");

  const { isDistrictOwner } = useUserRole();

  const { releaseNotesYears, isLoading } = useSelector<ApplicationState, SuperuserState>(
    (s) => s.superuser
  );
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined);

  useEffect(() => {
    if(noteYearParam) {
      setActiveKey(`releaseNote_${noteYearParam}`);
      handleReleaseNote(noteYearParam);
    }
  },[noteYearParam])

  useEffect(() => {
    if(!activeKey && !noteYearParam && releaseNotesYears.length) {
      let currentYear = new Date().getFullYear();
      if(!releaseNotesYears.includes(currentYear)) {
        currentYear = new Date().getFullYear() - 1;
      }
      setActiveKey(`releaseNote_${currentYear}`);
      handleReleaseNote(currentYear.toString());
    }
  },[releaseNotesYears])

  const handleTutorialChange = (newActiveKey: string | null) => {
    setActiveKey(newActiveKey ?? undefined);
  };

  const handleReleaseNote = (noteYear: string) => {
   if (noteYear) {
      dispatch(getAllReleaseNotes(noteYear));
    }
  };

  const handleReleaseNoteDetail = (noteYear: string, noteId: string) => {
    if (noteId) {
      dispatch(push(`${isDistrictOwner ? '/district' : ''}/release-notes/${noteId}?year=${noteYear}`));
    }
  };
  return (
    <div className="dataContainer">
      <h2 className="font-weight-bold">Release Notes</h2>
      <h4>ReadyCoach release notes highlight new features, enhancements, updates, and fixes. 
        Browse by year to view updates released across different versions of ReadyCoach.</h4>
      <hr/>
      {releaseNotesYears.length 
      ?
      <>
        {isLoading.getReleaseNotesYear ? (
          <LoadingIndicator />
        ) : 
        (<Accordion
          className="tutorialsAccordion"
          activeKey={activeKey}
          onSelect={handleTutorialChange}
        >
          {releaseNotesYears.sort((a, b) => b - a).map((year) => (
            <ReleaseNoteItem
              releaseNoteYear={year}
              key={`releaseNote_${year}`}
              activeKey={activeKey}
              onReleaseNoteDetail= {handleReleaseNoteDetail}
              onReleaseNote={handleReleaseNote}
            />
          ))}
        </Accordion>)
        }
      </>
      :
        <p className="font-weight-bold text-center">No Release Note(s) Available Yet.</p>
      }
    </div>
  );
};

export default ReleaseNotesTable;
